import AccountUnderReview from '../auth/components/AccountUnderReview';

export default function AccountUnderReviewPage() {
    return <AccountUnderReview />;
}
